import React from 'react';

import classes from './ThumbnailAndTitle.module.scss';

export const ThumbnailAndTitle = ({ url, title }: { url?: string; title: string }) => {
  const imageProps = url ? { style: { backgroundImage: `url(${url})` } } : {};
  return (
    <div className={classes.container}>
      <div className={classes.image} {...imageProps} />
      <div className={classes.title}>{title}</div>
    </div>
  );
};
